/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Option,
  OverflowTooltip,
  Select,
  Space,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableScrollbar,
  Text,
  TextLabel,
  Truncate,
  Tooltip,
} from '@tonic-one/react';
import { AddIcon, ArrowDownIcon, DeleteIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import { DlpTemplateModalNameEnum, DlpTemplateModalState } from '../type';
import React, { useEffect, useMemo, useState } from 'react';
import { PolicyApi } from '@Apis';
import cloneDeep from 'lodash/cloneDeep';

import { dlpTemplateDetail as defaultDlpTemplateDetail } from '@Policy/TemplateConfig/cfg.dlp.default';
import i18next from 'i18next';
import {
  BuildingBlock,
  BuildingBlockTypeEnum,
  DlpExpression,
  DlpKeyword,
  DlpOperatorEnum,
  DlpTemplateDetail,
  DpBuiltinEnum,
  TableColumn,
  TemplateRule,
} from '@Policy/utils/types';
import IconButton from '@Components/IconButton';
import { useDlpConditionStatementStyle } from '@Policy/DataLossPrevention/Components/DlpTemplateModal/style';
import { FormLabel } from '@Components/Common/FormComponent';
import LoadingBtn from '../../../../../components/Common/LoadingBtn';
import { PermissionNameEnum } from '@Types/permissions';
import { usePermissionStore } from '@Models/usePermissionModel';

// {
//   "dpTemplateName": "ant name",
//   "dpTemplateDesc": "ant desc",
//   "template": {
//       "matchRule": [
//           {
//               "buildingBlock": [
//                   {
//                       "displayName": "Albania: IBAN (International Bank Account Number)",
//                       "sourceName": "00000000-0000-0000-0001-000000000059",
//                       "sourceType": "ENTITY",
//                       "entityHits": "44"
//                   },
//                   {
//                       "displayName": "Racism",
//                       "sourceName": "00000000-0000-0000-0002-000000000011",
//                       "sourceType": "KEYWORD"
//                   }
//               ],
//               "operation": "OR"
//           }
//       ]
//   }
// }

export const EditOrAddModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpTemplateModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  const cfgIndex = modalState.data?.cfgIndex as string | undefined;
  const modalName = modalState.name as
    | DlpTemplateModalNameEnum.Add
    | DlpTemplateModalNameEnum.Edit;

  const { t } = useTranslation();
  const { widthEditablePermission } = usePermissionStore();
  const [dlpTemplateDetail, setDlpTemplateDetail] = useState<DlpTemplateDetail>(
    cloneDeep(defaultDlpTemplateDetail)
  );

  const setMatchRule = (payload: TemplateRule[]) => {
    setDlpTemplateDetail({
      ...dlpTemplateDetail,
      template: {
        ...dlpTemplateDetail.template,
        matchRule: payload,
      },
    });
  };
  const [expressionList, setExpressionList] = useState<DlpExpression[]>([]);
  const [keywordList, setKeywordList] = useState<DlpKeyword[]>([]);
  const [error, setError] = useState<null | string>(null);
  const onSave = async () => {
    if (dlpTemplateDetail.dpTemplateName.trim() === '') {
      setError('name empty!');
      return;
    }
    try {
      if (cfgIndex) {
        await PolicyApi.updateDlpTemplateById(
          modalState.data?.cfgIndex,
          dlpTemplateDetail
        );
      } else {
        await PolicyApi.addDlpTemplate(dlpTemplateDetail);
      }
      window.showNotification({
        severity: 'success',
        titleMsg: t('policy.complianceTemplates.saveSuccessfully'),
      });
    } catch (error: any) {
      const code = error?.status || 'Unknown';
      if (code === 400 && error.data.error.details[0].code === -118) {
        window.showNotification({
          severity: 'error',
          titleMsg: t('errors.policy.POLICY_API;UPSERT_TEMPLATE_FAILURE;-118'),
        });
      } else {
        window.showNotification({
          severity: 'error',
          titleMsg: t('common.apiException.internalError'),
        });
      }
    } finally {
      refreshTable();
      onClose();
    }
  };

  useEffect(() => {
    (async () => {
      if (cfgIndex) {
        const data = (
          await PolicyApi.getDlpTemplateById(cfgIndex, i18next.language)
        ).data;
        //if template is copied from pre-defined template, matchRule[0] doesn't have operation field
        if (
          data.template.matchRule.length > 0 &&
          data.template.matchRule[0].operation !== DlpOperatorEnum.except
        ) {
          data.template.matchRule[0].operation = DlpOperatorEnum.none;
        }
        setDlpTemplateDetail(data);
      }
      const expressionListData = (
        await PolicyApi.getDlpExpressions(i18next.language)
      ).data;
      const keywordListData = (await PolicyApi.getDlpKeywords(i18next.language))
        .data;
      setExpressionList(expressionListData);
      setKeywordList(keywordListData);
      // setPageLoading(false);
    })();
  }, []);

  // if (pageLoading) {
  //   return <CSpinner />;
  // }
  if (
    modalName !== DlpTemplateModalNameEnum.Add &&
    modalName !== DlpTemplateModalNameEnum.Edit
  ) {
    return <></>;
  }

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={true}
      onClose={onClose}
      size="lg"
      scrollBehavior="inside"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent height="default">
        <ModalHeader>
          {cfgIndex
            ? t('policy.modal.complianceTemplate.editTitle')
            : t('policy.modal.complianceTemplate.addTitle')}
        </ModalHeader>
        <ModalBody>
          <Box minHeight={400} px="3x">
            <Text fontWeight="600" fontSize="18px" lineHeight="24px">
              {t('policy.modal.complianceTemplate.basicProperties')}
            </Text>
            <Grid
              templateColumns="max-content auto"
              columnGap="3x"
              rowGap="3x"
              mt="16px"
            >
              <Grid>
                <FormLabel label={t('common.label.enterName')} required />
              </Grid>
              <Grid>
                <Input
                  type="text"
                  maxLength={256}
                  onChange={(e: any) => {
                    setError(null);
                    setDlpTemplateDetail({
                      ...dlpTemplateDetail,
                      dpTemplateName: e.target.value,
                    });
                  }}
                  error={!!error}
                  value={dlpTemplateDetail.dpTemplateName}
                />
              </Grid>
              <Grid>
                <FormLabel label={t('common.label.description')} />
              </Grid>
              <Grid>
                <Input
                  type="text"
                  maxLength={1024}
                  onChange={(e: any) => {
                    setDlpTemplateDetail({
                      ...dlpTemplateDetail,
                      dpTemplateDesc: e.target.value,
                    });
                  }}
                  value={dlpTemplateDetail.dpTemplateDesc}
                />
              </Grid>
            </Grid>
            <Divider my="10px" />
            {expressionList.length > 0 && (
              <RuleDefinitions
                expressionList={expressionList}
                keywordList={keywordList}
                matchRule={dlpTemplateDetail.template.matchRule}
                setMatchRule={setMatchRule}
              />
            )}
            <Divider my="10px" />
            <TemplateRules
              matchRule={dlpTemplateDetail.template.matchRule}
              setMatchRule={setMatchRule}
            />
          </Box>
        </ModalBody>
        <ModalFooter>
          <Tooltip
            label={
              dlpTemplateDetail?.dpTemplateBuiltin === DpBuiltinEnum.Predefined
                ? t('policy.complianceTemplates.predefinedEditTooltip')
                : undefined
            }
            PopperProps={{ usePortal: true }}
          >
            <Box display="inline-block">
              <LoadingBtn
                minWidth="20x"
                onClick={onSave}
                variant="primary"
                disabled={
                  dlpTemplateDetail?.dpTemplateBuiltin ===
                    DpBuiltinEnum.Predefined ||
                  !widthEditablePermission(PermissionNameEnum.dlpPolicy)
                }
              >
                {(loading: boolean) => {
                  return loading
                    ? t('reportCommon.buttons.saving')
                    : t('reportCommon.buttons.save');
                }}
              </LoadingBtn>
            </Box>
          </Tooltip>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const RuleDefinitions = ({
  expressionList,
  keywordList,
  matchRule,
  setMatchRule,
}: {
  expressionList: DlpExpression[];
  keywordList: DlpKeyword[];
  matchRule: TemplateRule[];
  setMatchRule: (payload: TemplateRule[]) => void;
}) => {
  const { t } = useTranslation(['policy', 'common']);
  const initBlockingList: BuildingBlock[] = [
    {
      sourceName: expressionList[0].dpExpressionInternalname,
      sourceType: BuildingBlockTypeEnum.entity, //这就是 Expression
      displayName: expressionList[0].dpExpressionName,
      entityHits: 1,
    },
  ];
  const [blockingList, setBlockingList] = useState(initBlockingList);
  const appendBlockingList = () => {
    const copyBlockingList = cloneDeep(blockingList);
    copyBlockingList.push({
      sourceName: expressionList[0].dpExpressionInternalname,
      sourceType: BuildingBlockTypeEnum.entity,
      displayName: expressionList[0].dpExpressionName,
      entityHits: 1,
    });
    setBlockingList(copyBlockingList);
  };

  const deleteBlockingListByIndex = (index: number) => {
    const copyBlockingList = cloneDeep(blockingList);
    copyBlockingList.splice(index, 1);
    setBlockingList(copyBlockingList);
  };

  const setBlockingListByIndex = (
    index: number,
    payload: Partial<BuildingBlock>
  ) => {
    const copyBlockingList = cloneDeep(blockingList);
    copyBlockingList[index] = {
      ...copyBlockingList[index],
      ...payload,
    };
    setBlockingList(copyBlockingList);
  };

  const clearBlockingList = () => {
    setBlockingList(initBlockingList);
  };

  const appendTemplateRules = () => {
    const copyMatchRule = cloneDeep(matchRule);
    copyMatchRule.push({
      buildingBlock: blockingList,
      operation: DlpOperatorEnum.and,
    });
    setMatchRule(copyMatchRule);
    clearBlockingList();
  };

  const columns: TableColumn[] = React.useMemo(
    () => [
      {
        id: 'sourceType',
        header: 'Data identifier type', //header no need to show
        cell: (row: any, rowIndex: number) => {
          return (
            <Select
              value={row.sourceType}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                const sourceType = e.target.value as BuildingBlockTypeEnum;
                if (sourceType === BuildingBlockTypeEnum.entity) {
                  if (expressionList[0]) {
                    setBlockingListByIndex(rowIndex, {
                      sourceName: expressionList[0].dpExpressionInternalname,
                      sourceType: BuildingBlockTypeEnum.entity,
                      displayName: expressionList[0].dpExpressionName,
                      entityHits: 1,
                    });
                  }
                } else {
                  if (keywordList[0]) {
                    setBlockingListByIndex(rowIndex, {
                      sourceName: keywordList[0].dpKeywordInternalname,
                      sourceType: BuildingBlockTypeEnum.keyword,
                      displayName: keywordList[0].dpKeywordName,
                    });
                  }
                }
              }}
            >
              <Option
                value={BuildingBlockTypeEnum.entity}
                key={BuildingBlockTypeEnum.entity}
              >
                {t('policy.modal.complianceTemplate.expressions')}
              </Option>
              <Option
                value={BuildingBlockTypeEnum.keyword}
                key={BuildingBlockTypeEnum.keyword}
              >
                {t('policy.modal.complianceTemplate.keywordLists')}
              </Option>
            </Select>
          );
        },
        size: 155,
      },
      {
        id: 'displayName',
        header: 'Data identifier name', //header no need to show
        cell: (row: any, rowIndex: number) => {
          return (
            <Select
              value={row.sourceName}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                const sourceName = e.target.value;
                let displayName;
                if (row.sourceType === BuildingBlockTypeEnum.entity) {
                  displayName = expressionList.find(
                    (expression) =>
                      expression.dpExpressionInternalname === sourceName
                  )?.dpExpressionName;
                }
                if (row.sourceType === BuildingBlockTypeEnum.keyword) {
                  displayName = keywordList.find(
                    (keyword) => keyword.dpKeywordInternalname === sourceName
                  )?.dpKeywordName;
                }
                if (!displayName) {
                  console.error('something wrong');
                } else {
                  setBlockingListByIndex(rowIndex, {
                    sourceName: e.target.value,
                    displayName,
                    entityHits: 1,
                  });
                }
              }}
            >
              {row.sourceType === BuildingBlockTypeEnum.entity
                ? expressionList.map((expression) => (
                    <Option
                      value={expression.dpExpressionInternalname}
                      key={expression.cfgIndex}
                    >
                      {expression.dpExpressionName}
                    </Option>
                  ))
                : keywordList.map((keyword) => (
                    <Option
                      value={keyword.dpKeywordInternalname}
                      key={keyword.cfgIndex}
                    >
                      {keyword.dpKeywordName}
                    </Option>
                  ))}
            </Select>
          );
        },
        size: 450,
      },
      {
        id: 'entityHits',
        header: 'Occurrences', //header no need to show
        cell: (row: any, rowIndex: number) => {
          if (row.sourceType === BuildingBlockTypeEnum.entity) {
            return (
              <Input
                type="number"
                maxLength={4}
                value={row.entityHits + ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  if (e.target.value === '') {
                    setBlockingListByIndex(rowIndex, {
                      entityHits: 0,
                    });
                    return;
                  }
                  const num = parseInt(e.target.value);
                  if (!isNaN(num)) {
                    setBlockingListByIndex(rowIndex, {
                      entityHits: Math.min(Math.max(num, 1), 9999),
                    });
                  }
                }}
                onBlur={(e: any) => {
                  if (e.target.value === '0') {
                    setBlockingListByIndex(rowIndex, {
                      entityHits: 1,
                    });
                  }
                }}
              />
            );
          } else {
            return null;
          }
        },
        size: 100,
      },
      {
        id: 'deleteAction',
        header: 'Delete',
        cell: (row: any, rowIndex: number) => {
          return (
            <IconButton
              onClick={() => {
                deleteBlockingListByIndex(rowIndex);
              }}
              disabled={rowIndex === 0}
            >
              <Icon as={DeleteIcon}></Icon>
            </IconButton>
          );
        },
        size: 40,
      },
    ],
    [blockingList, expressionList, keywordList]
  );
  const rows = React.useMemo(() => {
    return blockingList.map((row, rowIndex) => {
      return {
        id: rowIndex,
        cells: columns.map((column: TableColumn, columnIndex: number) => {
          return {
            id: `${columnIndex}_${column.id}`,
            column,
            row,
          };
        }),
        row,
      };
    });
  }, [blockingList, columns]);

  const {
    tableStyleProps,
    tableHeaderStyleProps,
    hoverBackgroundColor,
    descriptionColor,
    cellHeight,
    headerHeight,
    templateTableMaxHeight,
    clearButtonColor,
  } = useDlpConditionStatementStyle();
  const tableHeight = useMemo(() => {
    //temp ignore header
    // const height = headerHeight + buildingBlockList.length * cellHeight;
    const height = 20 + blockingList.length * cellHeight;
    const result =
      height > templateTableMaxHeight ? templateTableMaxHeight : height;
    return result;
  }, [blockingList]);
  return (
    <Flex direction="column">
      <Text fontWeight="600" fontSize="18px" lineHeight="24px">
        {t('policy.modal.complianceTemplate.ruleDefinitions')}
      </Text>
      <TextLabel fontSize="14px" lineHeight="20px" mt="8px" mb="12px">
        {t('policy.modal.complianceTemplate.ruleDefinitionsDesc')}
      </TextLabel>
      <Table
        layout="flexbox"
        variant="default"
        size="md"
        {...tableStyleProps}
        height={tableHeight}
      >
        <TableScrollbar
          maxHeight="200px"
          overflow="visible" // Make the scrollbar visible
          overflowX="hidden"
        >
          <TableBody>
            {rows.map((row) => {
              const styleProps = {
                _hover: {
                  backgroundColor: hoverBackgroundColor,
                },
              };
              return (
                <TableRow key={row.id} {...styleProps}>
                  {row.cells.map((cell, cellIndex) => {
                    const styleProps = {
                      flex: 'none',
                      width: cell.column.size,
                      ...cell.column.style,
                    };
                    return (
                      <TableCell key={cell.id} {...styleProps}>
                        {typeof cell.column.cell === 'function' ? (
                          cell.column.cell(row.row, row.id)
                        ) : (
                          <Truncate>
                            {
                              cell.row[
                                cell.column.accessorKey as keyof typeof cell.row
                              ]
                            }
                          </Truncate>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </TableScrollbar>
      </Table>
      <Stack direction="row" shouldWrapChildren={true} spacing="8px" ml="6px">
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="secondary"
          onClick={appendBlockingList}
        >
          <Icon as={AddIcon} />
        </Button>
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="ghost"
          onClick={clearBlockingList}
          color={clearButtonColor}
        >
          <Icon as={DeleteIcon} />
          {t('common.action.label.clear')}
        </Button>
      </Stack>
      <Stack direction="row" shouldWrapChildren={true} my="16px" pl="4px">
        <Button
          borderRadius="2rem"
          columnGap="2x"
          variant="secondary"
          onClick={appendTemplateRules}
        >
          <Icon as={ArrowDownIcon} />
          {t('common.action.label.add')}
        </Button>
      </Stack>
    </Flex>
  );
};

const TemplateRules = ({
  matchRule,
  setMatchRule,
}: {
  matchRule: TemplateRule[];
  setMatchRule: (payload: TemplateRule[]) => void;
}) => {
  const { t } = useTranslation();
  const {
    tableStyleProps,
    headerHeight,
    cellHeight,
    templateTableMaxHeight,
    hoverBackgroundColor,
  } = useDlpConditionStatementStyle();
  const tableHeight = useMemo(() => {
    const height = headerHeight + matchRule.length * cellHeight;
    const result =
      height > templateTableMaxHeight ? templateTableMaxHeight : height;
    return result;
  }, [matchRule]);

  const setOperationByIndex = (index: number, operator: DlpOperatorEnum) => {
    const copyMatchRule = cloneDeep(matchRule);
    copyMatchRule[index].operation = operator;
    setMatchRule(copyMatchRule);
  };

  const deleteMatchRuleByIndex = (index: number) => {
    const copyMatchRule = cloneDeep(matchRule);
    copyMatchRule.splice(index, 1);
    setMatchRule(copyMatchRule);
  };

  const columns: TableColumn[] = React.useMemo(
    () => [
      {
        id: 'operation',
        header: 'Operator',
        cell: (row: any, rowIndex: number) => {
          if (rowIndex === 0) {
            return (
              <Select
                value={row.operation}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  setOperationByIndex(
                    rowIndex,
                    e.target.value as DlpOperatorEnum
                  );
                }}
              >
                <Option value={DlpOperatorEnum.none} key="none" />
                <Option
                  value={DlpOperatorEnum.except}
                  key={DlpOperatorEnum.except}
                >
                  EXCEPT
                </Option>
              </Select>
            );
          }
          return (
            <Select
              value={row.operation}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                setOperationByIndex(
                  rowIndex,
                  e.target.value as DlpOperatorEnum
                );
              }}
            >
              <Option value={DlpOperatorEnum.and} key={DlpOperatorEnum.and}>
                AND
              </Option>
              <Option value={DlpOperatorEnum.or} key={DlpOperatorEnum.or}>
                OR
              </Option>
              <Option
                value={DlpOperatorEnum.except}
                key={DlpOperatorEnum.except}
              >
                EXCEPT
              </Option>
            </Select>
          );
        },
        size: 155,
      },
      {
        id: 'definition',
        header: 'Definition',
        accessorKey: 'definition',
        size: 480,
      },
      {
        id: 'deleteAction',
        header: 'Delete',
        cell: (row: any, rowIndex: number) => {
          return (
            <IconButton
              onClick={() => {
                deleteMatchRuleByIndex(rowIndex);
              }}
            >
              <Icon as={DeleteIcon}></Icon>
            </IconButton>
          );
        },
        size: 100,
      },
    ],
    [matchRule]
  );
  const data = useMemo(() => {
    if (matchRule.length === 0) {
      return [];
    }
    const result = matchRule.map((rule: TemplateRule) => {
      const buildingBlockLength = rule.buildingBlock.length;

      const definition = rule.buildingBlock.reduce(
        (acc: string, cur: BuildingBlock, index: number) => {
          const prefix = acc ? acc : `${acc} `;
          const name = cur.displayName;
          const operator = 'AND';
          const hits =
            cur.sourceType === BuildingBlockTypeEnum.entity
              ? `(${cur.entityHits})`
              : '';
          const contetn = `${prefix}${name}${hits}`;
          if (index === buildingBlockLength - 1) {
            return contetn;
          } else {
            return `${contetn} ${operator} `;
          }
        },
        ''
      );
      return {
        definition,
        operation: rule.operation,
      };
    });
    return result;
  }, [matchRule]);

  const rows = React.useMemo(() => {
    return data.map((row, rowIndex: number) => {
      return {
        id: rowIndex,
        cells: columns.map((column: TableColumn, columnIndex: number) => {
          return {
            id: `${columnIndex}_${column.id}`,
            column,
            row,
          };
        }),
        row,
      };
    });
  }, [data, columns]);

  return (
    <Flex direction="column" mt="16px">
      <Text fontWeight="600" fontSize="18px" lineHeight="24px">
        {t('policy.modal.complianceTemplate.templateRules')}
      </Text>
      {matchRule.length === 0 ? (
        <TextLabel fontSize="14px" lineHeight="20px" mt="8px" mb="12px">
          {t('policy.modal.complianceTemplate.noneDefined')}
        </TextLabel>
      ) : (
        <Table
          layout="flexbox"
          variant="default"
          size="sm"
          {...tableStyleProps}
          height={tableHeight}
        >
          <TableScrollbar
            maxHeight="220px"
            overflow="visible" // Make the scrollbar visible
          >
            <TableBody width="98%">
              {rows.map((row) => {
                const styleProps = {
                  _hover: {
                    backgroundColor: hoverBackgroundColor,
                  },
                };
                return (
                  <TableRow key={row.id} {...styleProps} height="44px">
                    {row.cells.map((cell, cellIndex) => {
                      const styleProps = {
                        display: 'flex',
                        width: cell.column.size,
                        ...cell.column.style,
                        alignItems: 'center',
                      };
                      if (typeof cell.column.cell === 'function') {
                        return (
                          <TableCell key={cell.id} {...styleProps}>
                            {cell.column.cell(row.row, row.id)}
                          </TableCell>
                        );
                      }
                      const content =
                        cell.row[
                          cell.column.accessorKey as keyof typeof cell.row
                        ];
                      return (
                        <TableCell key={cell.id} {...styleProps}>
                          <OverflowTooltip
                            PopperProps={{ usePortal: true }}
                            label={content}
                          >
                            {content}
                          </OverflowTooltip>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </TableScrollbar>
        </Table>
      )}
    </Flex>
  );
};
